import React, { useState } from 'react';
import logoImage from '../assets/logo.png';
// import './Header.css';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const menuItems = [
    { href: '#home', label: 'Home' },
    { href: '#about', label: 'Story' },
    // { href: '#event', label: 'Event' },
    { href: '#memory', label: 'Gallery' },
    { href: '#rsvp', label: 'RSVP' },
    { href: '#bridegrooms', label: 'Bridegrooms' },
    { href: '#contact', label: 'Contact' }
  ];

  return (
    <header className="main-header header-style-seven" id="home">
      <div className="main-box">
        <div className="logo-box">
          <div className="logo">
            <a href="/" title="">
              <img src={logoImage} alt="Love Bite" />
            </a>
          </div>
        </div>

        <div className="nav-outer">
          <nav className="nav main-menu">
            <ul className="navigation onepage-nav">
              {menuItems.map((item, index) => (
                <li key={index}>
                  <a href={item.href}>{item.label}</a>
                </li>
              ))}
            </ul>
          </nav>
        </div>

        <div className="outer-box">
          <ul className="social-icon-two">
            <li><a href="#"><i className="icon fab fa-twitter"></i></a></li>
            <li><a href="#"><i className="icon fab fa-facebook-f"></i></a></li>
            <li><a href="#"><i className="icon fab fa-linkedin-in"></i></a></li>
          </ul>
        </div>

        <div className="mobile-nav-toggler" onClick={() => setIsMobileMenuOpen(true)}>
          <span className="icon lnr-icon-bars"></span>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="mobile-menu">
          <div className="menu-backdrop" onClick={() => setIsMobileMenuOpen(false)}></div>
          <nav className="menu-box">
            <div className="upper-box">
              <div className="nav-logo">
                <a href="#"><img src="/images/logo.png" alt="LoveBite" /></a>
              </div>
              <div className="close-btn" onClick={() => setIsMobileMenuOpen(false)}>
                <i className="icon fa fa-times"></i>
              </div>
            </div>
            <ul className="navigation clearfix">
              {menuItems.map((item, index) => (
                <li key={index}>
                  <a href={item.href} onClick={() => setIsMobileMenuOpen(false)}>
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      )}

      {/* Search Popup */}
      {isSearchOpen && (
        <div className="search-popup">
          <span className="search-back-drop" onClick={() => setIsSearchOpen(false)}></span>
          <button className="close-search" onClick={() => setIsSearchOpen(false)}>
            <span className="fa fa-times"></span>
          </button>
          <div className="search-inner">
            <form>
              <div className="form-group">
                <input type="search" placeholder="Search..." required />
                <button type="submit"><i className="fa fa-search"></i></button>
              </div>
            </form>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;